import { css, createGlobalStyle } from 'styled-components';

export function generateTooltipArrowStyle(color: string, className: string) {
  return css`
    .rc-tooltip.${className} {
      &.rc-tooltip-placement-top .rc-tooltip-arrow-inner,
      &.rc-tooltip-placement-top .rc-tooltip-arrow,
      &.rc-tooltip-placement-topLeft .rc-tooltip-arrow-inner,
      &.rc-tooltip-placement-topLeft .rc-tooltip-arrow,
      &.rc-tooltip-placement-topRight .rc-tooltip-arrow-inner,
      &.rc-tooltip-placement-topRight .rc-tooltip-arrow {
        border-top-color: ${color} !important;
      }

      &.rc-tooltip-placement-right .rc-tooltip-arrow-inner,
      &.rc-tooltip-placement-right .rc-tooltip-arrow,
      &.rc-tooltip-placement-rightTop .rc-tooltip-arrow-inner,
      &.rc-tooltip-placement-rightTop .rc-tooltip-arrow,
      &.rc-tooltip-placement-rightBottom .rc-tooltip-arrow-inner,
      &.rc-tooltip-placement-rightBottom .rc-tooltip-arrow {
        border-right-color: ${color} !important;
      }

      &.rc-tooltip-placement-left .rc-tooltip-arrow-inner,
      &.rc-tooltip-placement-left .rc-tooltip-arrow,
      &.rc-tooltip-placement-leftTop .rc-tooltip-arrow-inner,
      &.rc-tooltip-placement-leftTop .rc-tooltip-arrow,
      &.rc-tooltip-placement-leftBottom .rc-tooltip-arrow-inner,
      &.rc-tooltip-placement-leftBottom .rc-tooltip-arrow {
        border-left-color: ${color} !important;
      }

      &.rc-tooltip-placement-bottom .rc-tooltip-arrow-inner,
      &.rc-tooltip-placement-bottom .rc-tooltip-arrow,
      &.rc-tooltip-placement-bottomLeft .rc-tooltip-arrow-inner,
      &.rc-tooltip-placement-bottomLeft .rc-tooltip-arrow,
      &.rc-tooltip-placement-bottomRight .rc-tooltip-arrow,
      &.rc-tooltip-placement-bottomRight .rc-tooltip-arrow-inner {
        border-bottom-color: ${color} !important;
      }
    }
  `;
}

export const TooltipCss = css`
  ${({ theme }) => generateTooltipArrowStyle(theme.color.surface.inverse, 'ui-tooltip-large')}
  ${({ theme }) => generateTooltipArrowStyle(theme.color.surface.info, 'ui-tooltip-small')}
`;

export const ToolTipStyles = createGlobalStyle`${TooltipCss}`;
